import { AxiosInstance } from "axios";
import { useDispatch } from "react-redux";
import { setNewTokens } from "../../utils/auth/getTokensLocalStorage";
import { setToken } from "../../store/auth/actions";
import {
  Auth2FARequestService,
  AuthLoginResponseService,
  AuthRequestService,
  AuthSignUpResponseService,
} from "./AuthenticationServices.type";

export default class AuthService {
  private axios: AxiosInstance;
  public dispatch = useDispatch();
  constructor(axios: AxiosInstance) {
    this.axios = axios;
  }

  public async signUp(
    req: AuthRequestService,
  ): Promise<AuthSignUpResponseService> {
    const url: string = "/auth/signup";
    const axiosResponse: AuthSignUpResponseService = await this.axios.post(
      url,
      req,
    );
    return axiosResponse;
  }

  public async login(
    req: AuthRequestService,
  ): Promise<any> {
    const url: string = "/auth/loginPC";
    const axiosResponse: AuthLoginResponseService = await this.axios.post(
      url,
      req,
    );
    this.dispatch(setToken(axiosResponse));
    setNewTokens(axiosResponse);

    return axiosResponse;
  }
  public async verify2fa(
    req: Auth2FARequestService,
  ): Promise<AuthLoginResponseService> {
    const url: string = "/auth/login/2fa";
    const axiosResponse: AuthLoginResponseService = await this.axios.post(
      url,
      req,
    );
    this.dispatch(setToken(axiosResponse));
    setNewTokens(axiosResponse);

    return axiosResponse;
  }

  public async sendValidationWsp(username: string): Promise<string> {
    const url: string = `/auth/sendValidationWsp/${username}`;
    const res: string = await this.axios.post(url);
    return res;
  }

  public async logout(): Promise<void> {
    this.dispatch({
      type: "Log Out",
      payload: null
    });
  }
}
